import * as React from 'react';
import {
  Button,
  ButtonWidth,
} from '@practicegenius/pg-ui/src/base/Material/components/Button';
import {Field} from '../../../@practicegenius/react-final-form';
import {Modal} from '../../../components/Modal/Modal';
import {ModalButtons} from '../../../components/Modal/layout';
import {Content, Title} from '../../../shared/utils/sharedStyledElements';
import {Link} from '../../../components/Link';

type Props = {
  isOpen: boolean;
  close: () => void;
  redirectTo: string;
};

export function OrphanedAccountModal({isOpen, close, redirectTo}: Props) {
  return (
    <Modal isOpen={isOpen} close={close}>
      <Title>Account Setup Incomplete</Title>
      <Content>
        Your account registration is not complete. Please finish the
        registration by inputting your rewards number on the next screen or
        contact us at <Link href="tel:800-560-1469">(800) 560-1469</Link>.
      </Content>
      <ModalButtons>
        <Button color="secondary" width={ButtonWidth.WIDE} onClick={close}>
          Cancel
        </Button>
        <Field name="login">
          {() => (
            <Button
              width={ButtonWidth.WIDE}
              color="primary"
              href={redirectTo}
              data-testid="register"
            >
              Finish with rewards number
            </Button>
          )}
        </Field>
      </ModalButtons>
    </Modal>
  );
}
